import { Component } from "@angular/core";
import { faBan } from "@fortawesome/free-solid-svg-icons";
import RouteNameConstants from "src/app/constants/route-name-constants";

@Component({
  selector: "app-no-access",
  templateUrl: "./no-access.component.html",
  styleUrls: ["./no-access.component.scss"],
  standalone: false,
})
export class NoAccessComponent {
  readonly routeNameConstants = RouteNameConstants;

  faBan = faBan;

  constructor() {}
}
